const AppRoutes = [
  {
    index: true,
    path: "/",
    icon: "estates",
    name: "Biens",
  },
  // {
  //   path: "/documents",
  //   icon: "documents",
  //   name: "Documents",
  // },
  {
    path: "/upload",
    icon: "upload",
    name: "Upload Doc",
  },
  // {
  //   path: "/users",
  //   icon: "users",
  //   name: "Utilisateurs",
  // },
];

export default AppRoutes;
